import { Accordeon } from 'components/Accordeon'
import { LocaleContext } from 'components/MainComponent/MainComponent'
import { useContext } from 'react'
import styled from 'styled-components'

const groups = [
  [0, 0.3],
  [0.3, 0.5],
  [0.5, 0.8],
  [0.8, 1],
  [1, 2],
  [2, 3],
  [3, 1000],
]

export const PromilleTabelle = ({
  alcoholcolor,
  headcolor,
  bgcolor,
  currentGroup,
}: {
  alcoholcolor: string
  headcolor: string
  bgcolor: string
  currentGroup: number
}) => {
  const TEXT = useContext(LocaleContext)
  const Phasen = [...Array(7)].map((m, i) => [
    TEXT['promillePhase_' + (i + 1) + '_title'],
    TEXT['promillePhase_' + (i + 1) + '_value'],
    TEXT['promillePhase_' + (i + 1) + '_list'],
  ])
  console.log(
    currentGroup,
    groups.findIndex((g) => currentGroup >= g[0] && currentGroup < g[1])
  )
  return (
    <PromilleTabelleRoot>
      {Phasen.map((phase, i) => {
        return (
          <Accordeon
            open={
              groups.findIndex(
                (g) => currentGroup >= g[0] && currentGroup < g[1]
              ) === i
            }
            head={
              <PhaseTitle
                style={{
                  backgroundColor: 'var(--site-background)',
                  color: 'var(--text-color)',
                }}
              >
                {phase[0]}
              </PhaseTitle>
            }
            tail={
              <>
                <PhaseList style={{ backgroundColor: bgcolor }}>
                  <span>{TEXT.promille_table[0]}</span>
                  <div>{phase[1]}</div>
                </PhaseList>
                <PhaseList style={{ backgroundColor: bgcolor }}>
                  <span>{TEXT.promille_table[1]}</span>
                  <div>{phase[2]}</div>
                </PhaseList>
              </>
            }
          ></Accordeon>
        )
      })}
    </PromilleTabelleRoot>
  )
}

const PromilleTabelleRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin-left: -15px;
  width: calc(100% + 30px);
`

const PhaseTitle = styled.div`
  font-weight: 400;
  font-size: 15px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0.5em;
  /* padding-bottom: 0.5em; */
  border-top: 1px solid #202346;
  flex: 0 0 100%;
  @media only screen and (max-width: 711px) {
    max-width: 100%;
  }
`

const PhaseList = styled.ul`
  font-size: 15px;
  line-height: 1.3em;
  list-style-position: outside;
  margin: 0;
  border-top: 1px solid var(--site-background);
  /* background-color: #f8f8f8; */
  color: var(--text-color);
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 5px;
  padding-bottom: 15px;
  max-width: 100%;
  div {
    width: calc(100% - 30px);
  }
  span {
    display: inline-block;
    font-size: 13px;
    margin-bottom: 2px;
    color: var(--gray-3);
    letter-spacing: 0.2px;
  }
`

const PhaseListEntry = styled.li`
  margin-bottom: 10px;
  max-width: 90%;
`
